module.exports = __webpack_public_path__ + "img/img62.f8714e75.svg";